import useIntl from '@/utils/intl'
import { resolveImageUrl } from '@/utils/constants'
import Image from 'next/image' // Assuming you're using Next.js for image optimization

interface MessagePackageProps {
  data: Array<{
    id: string
    nameEn: string
    nameMn: string
    icon: string
    roaming_zone?: {
      nameEn: string
      nameMn: string
    }
    typePackageEn?: string
    typePackageMn?: string
    TimeEn?: string
    TimeMn?: string
    PriceEn?: string
    PriceMn?: string
    message_packages?: Array<{ // Add this line
      typePackageEn?: string
      typePackageMn?: string
      TimeEn?: string
      TimeMn?: string
      PriceEn?: string
      PriceMn?: string
    }> // Specify the structure of the message_packages
  }>
  selectedService: string | null
  locale: 'en' | 'mn'
  IMG_URL: string
}

const MessagePackage: React.FC<MessagePackageProps> = ({ data, selectedService, locale, IMG_URL }) => {
  const { translate } = useIntl()
  const filteredData = selectedService != null
    ? data.filter((item) => item.id === selectedService)
    : data

  return (
    <>
    <table className="hidden xl:block w-full text-sm text-left rtl:text-right">
        <thead className="text-xs uppercase bg-surfaceLow w-full">
          <tr className='h-16'>
            <th scope="col" className="px-6 py-3 text-center">{translate('roamingRegion')}</th>
            <th scope="col" className="px-6 py-3 text-center">{translate('roamingCountry')}</th>
            <th scope="col" className="px-6 py-3 text-center">{translate('roamingDataPackage')}</th>
          </tr>
        </thead>
        <tbody>
          {
            filteredData?.length > 0
              ? (
                filteredData.map((item, index) => (
                  <tr key={index} className="border-b border-secondaryMidStroke">
                    <th scope="row" className="px-6 py-4 whitespace-nowrap ">
                      <h1 className='text-center font-normal'>
                        {locale === 'en' ? item?.roaming_zone?.nameEn : item?.roaming_zone?.nameMn}
                      </h1>
                    </th>
                    <td className="px-6 py-4">
                      <div className="ps-3 ml-5 flex items-center justify-start space-x-5">
                        <Image className="w-10 h-10 rounded-full" alt='' width={10} height={10} src={resolveImageUrl(item.icon)} />
                        <div className="font-normal text-start">
                          {locale === 'en' ? item.nameEn : item.nameMn ?? 'No Name'}
                        </div>
                      </div>
                    </td>
                    <td className='w-full'>
                      <div className='flex justify-center w-full gap-2 p-1'>
                      {(item.message_packages != null) && item.message_packages.length > 0
                      ? (
                          item.message_packages.map((item: any, index: any) => (
                            <div key={index} className='flex flex-col justify-between border border-secondaryHighStroke p-2 rounded-xl'>
                              <div key={index} className=''>
                                <div className='flex justify-between'>
                                  <h1 className='text-sm'>{translate('roamingType')}:</h1><h1 className='text-center font-bold'>{locale === 'en' ? item?.typePackageEn : item?.typePackageMn}</h1>
                                </div>
                                <div className='flex justify-between'>
                                  <h1 className='text-sm'>{translate('roamingDuration')}:</h1><h1 className='text-center font-bold'>{locale === 'en' ? item?.TimeEn : item?.TimeMn}</h1>
                                </div>
                                <div className='flex justify-between'>
                                  <h1 className='text-sm'>{translate('roamingTariff')}:</h1><h1 className='text-center font-bold'>{locale === 'en' ? item?.PriceEn : item?.PriceMn}</h1>
                                </div>
                              </div>
                            </div>
                          ))
                        )
                      : (
                        <></>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (<></>)
          }
        </tbody>
      </table>
      {filteredData?.length > 0
        ? (
            filteredData.map((item, index) => (
              <div key={index} className=''>
                <div className='block xl:hidden'>
                  <div key={index} className='flex space-y-5 flex-col my-5 pb-2 border border-secondaryMidStroke rounded-xl'>
                    <div className='flex justify-between items-center bg-surfaceLow rounded-t-xl p-5'>
                      <h1 className='text-center'>{item?.roaming_zone?.nameMn}</h1>
                      <div className='flex justify-center items-center space-x-2'>
                        <Image className=' rounded-full' alt='' width={30} height={30} src={resolveImageUrl(item.icon)} />
                        <h1 className='text-center'>{locale === 'en' ? item.nameEn : item.nameMn ?? 'No Name'}</h1>
                      </div>
                    </div>
                    {(item.message_packages != null) && item.message_packages.length > 0
                      ? (
                          item.message_packages.map((item: any, index: any) => (
                            <div key={index} className='flex flex-col m-2 justify-between border border-secondaryHighStroke p-2 rounded-xl'>
                              <div key={index} className=''>
                                <div className='flex justify-between'>
                                  <h1 className='text-sm'>{translate('roamingType')}:</h1><h1 className='text-center font-bold'>{locale === 'en' ? item?.typePackageEn : item?.typePackageMn}</h1>
                                </div>
                                <div className='flex justify-between'>
                                  <h1 className='text-sm'>{translate('roamingDuration')}:</h1><h1 className='text-center font-bold'>{locale === 'en' ? item?.TimeEn : item?.TimeMn}</h1>
                                </div>
                                <div className='flex justify-between'>
                                  <h1 className='text-sm'>{translate('roamingTariff')}:</h1><h1 className='text-center font-bold'>{locale === 'en' ? item?.PriceEn : item?.PriceMn}</h1>
                                </div>
                              </div>
                            </div>
                          ))
                        )
                      : (
                        <></>
                        )}
                  </div>

                </div>
              </div>
            ))
          )
        : (
          <></>
          )}
    </>
  )
}

export default MessagePackage
